import { useAptabase } from "@aptabase/react";
import {
  useFetchPlayersByStats,
  useFetchTeamsByStats,
} from "../../../api/hooks";
import i18n from "../../../i18n";
import PageContainer from "../../../uikit/PageContainer/PageContainer";
import { useEffect } from "react";
import { PersonsRanking } from "../components/PersonsRanking";
import { TeamsRanking } from "../components/TeamsRanking";

const StatsPage = () => {
  const { data: playerByTries } = useFetchPlayersByStats("tries");
  const { data: playerByPoints } = useFetchPlayersByStats("points");
  const { data: teamByPointsScored } = useFetchTeamsByStats("points_scored");
  const { data: teamByPointsTaken } = useFetchTeamsByStats("points_taken");

  const { trackEvent } = useAptabase();

  useEffect(() => {
    trackEvent("page_view", { screenName: "stats_page" });
  }, [trackEvent]);

  return (
    <PageContainer title={i18n.t("navigation:stats:title")}>
      <div className="grid sm:grid-cols-1 md:grid-cols-2">
        <PersonsRanking
          label={"Meilleurs marqueurs"}
          persons={
            playerByTries
              ? playerByTries.map((player) => ({
                  ...player.fields,
                  id: player.id,
                  points: player.fields.tries,
                }))
              : []
          }
          pointLabel={"essais"}
        />
        <PersonsRanking
          label={"Meilleurs réalisateurs"}
          persons={
            playerByPoints
              ? playerByPoints.map((player) => ({
                  ...player.fields,
                  id: player.id,
                  points: player.fields.points,
                }))
              : []
          }
          pointLabel={"points"}
        />
      </div>
      <div className="grid sm:grid-cols-1 md:grid-cols-2">
        <TeamsRanking
          label={"Meilleures attaques"}
          teams={
            teamByPointsScored
              ? teamByPointsScored.map((team) => ({
                  ...team.fields,
                  id: team.id,
                  points: team.fields.points_scored,
                }))
              : []
          }
          pointLabel={"points marqués"}
        />
        <TeamsRanking
          label={"Meilleurs défenses"}
          teams={
            teamByPointsTaken
              ? teamByPointsTaken.map((team) => ({
                  ...team.fields,
                  id: team.id,
                  points: team.fields.points_taken,
                }))
              : []
          }
          pointLabel={"points encaissés"}
        />
      </div>
    </PageContainer>
  );
};

export default StatsPage;
